/**
 * The sword on a look (lane SWORD): `Look.sword` and what a weapon item's look key adds for it. Light on purpose
 * (no rig imports): sprites.ts merges outfits through `swordLook` and must not pull the figure modules in early.
 */
import type { Look } from '../../looks/types';
import { SWORD_FOR_VISUAL } from './catalog';

declare module '../../looks/types' {
  interface Look {
    /** The sword's look (swordParts/catalog.ts id); left out, the default. */
    sword?: string;
  }
}

/** What an outfit key adds for the sword: `sword:<id>` names one, a weapon item's look maps to one. */
export function swordLook(key: string): Partial<Look> | undefined {
  if (key.startsWith('sword:')) return { sword: key.slice(6) };
  const id = SWORD_FOR_VISUAL[key];
  return id ? { sword: id } : undefined;
}
